import { AxiosError } from 'axios';
import instance from '../config/axios';
import {
  FetchDosageDiaryProductQuery,
  FetcHDosageDiaryProductResult,
} from '../interface/interface';
import { stringify } from 'qs';

export async function fetchDosageDiaryProducts(
  token: string,
  query: Partial<FetchDosageDiaryProductQuery>,
): Promise<number | Array<FetcHDosageDiaryProductResult>> {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/dosasgedairy/products?${stringify(query)}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
}
